import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import Spinner from '../../components/generics/Spinner';
import Modal from '../../components/generics/Modal';
import { SCAN_SCANNING, SCAN_OK, SCAN_ERROR } from "../../components/generics/QRScanner";
import ChangeItemSubstituteModal from "../../components/orders/ChangeItemSubstituteModal";
import PackageCreator from '../../components/shipments/PackageCreator';
import ShipmentDetailHeader from '../../components/shipments/ShipmentDetailHeader';
import ShipmentItemsList from '../../components/orders/ShipmentItemsList';
import Package from '../../components/shipments/Package';

import { fetchGrades, fetchGradesSuccess, fetchGradesFailure } from "../../store/inventories/actions";
import {
  fetchOrderDetail,
  fetchOrderDetailSuccess,
  fetchOrderDetailFailure,
  fetchBackOrderDetail,
  fetchBackOrderDetailSuccess,
  fetchBackOrderDetailFailure,
  changeOrderItemBackOrder,
  changeOrderItemCompletedNotBackOrder,
} from "../../store/orders/actions";
import {
  fetchShipment,
  fetchShipmentSuccess,
  fetchShipmentFailure,
  updateShipment,
  updateShipmentSuccess,
  updateShipmentFailure,
  fetchDestinations,
  fetchDestinationsSuccess,
  fetchDestinationsFailure,
  fetchPackageTypes,
  fetchPackageTypesSuccess,
  fetchPackageTypesFailure,
  createPackage,
  createPackageSuccess,
  createPackageFailure,
  deletePackage,
  deletePackageSuccess,
  deletePackageFailure,
  addPackageToState,
  deletePackageFromState,
  addItemToPackage,
  deleteItemFromPackage,
} from "../../store/shipments/actions";
import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";
import { fetchItems, fetchItemsSuccess, fetchItemsFailure } from "../../store/inventories/actions";

import { changeBackOrderStatus, changeItemForSubstitute, changeItemCompletedNotBackOrderStatus } from "../../store/orders/api";
import { finishShipment } from '../../store/shipments/api';
import { getItems, getItemFromInventory } from "../../store/inventories/api";

import Alert from '../../utils/Alert';

import { SCAN_MESSAGE_DISPLAY_TIME_MS } from "../../constants/constants";
import { withRouter } from "utils/WithRouter";

const getAddedItemsId = (packages) => {
  return _.uniq(_.flatMap(packages, (pkg) => {
    return pkg.items.map((item) => {
      return item.item.id;
    })
  }));
}

export class ShipmentEditContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      isChangeDestinationModalOpen: false,
      selectedDestination: undefined,
      isChangeDateModalOpen: false,
      selectedDate: undefined,
      itemsAdded: [],
      finishErrors: {
        missingItems: [],
        fulfilledInBackOrder: []
      },
      itemsList: [],
      itemToSubstitute: { id: undefined, grade: undefined, name: undefined },
      maximumQtyToSubstitute: 0,
      isChangeSubstituteItemModalOpen: false,
      selectedButcherItem: {
        item_index: -1,
        item_info: null,
        item_allows_grade_order: false,
      },
      selectedButcherItemGrade: {
        grade_index: -1,
        grade_info: -1,
      },
      errorSubstituteGrade: false,
      selectedButcherItemQty: "",
      errorSubstituteQty: false,
      selectedButcherInventoryId: undefined,
      showQRScannerModal: false,
      scanResult: '',
      scanStatus: SCAN_SCANNING,
      scannedId: undefined,
      scannedItem: undefined,
    }

    this.debounceInputChange = _.debounce(this.handleScannedInventory, 300);

    this.alertRef = React.createRef();
  }

  componentDidMount(){
    this.props.fetchShipment(this.props.match.params.id);
    this.props.fetchPackageTypes();
    if (this.props.destinationsList.destinations.length === 0) {
      this.props.fetchDestinations(this.alertRef);
    }
    this.props.filterItems();
    this.props.fetchGrades();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.createEditShipment.loading && !this.props.createEditShipment.loading) {
      this.setState({
        selectedDestination: this.props.createEditShipment.shipment.destination.id
      });
      const shipmentAlreadyLoaded = prevProps.createEditShipment.shipment && prevProps.createEditShipment.shipment.id;
      const shipmentId = prevProps.match.params.id;
      // If no shipment was loaded
      if ((!shipmentAlreadyLoaded && this.props.createEditShipment.shipment.id) || (
        // Or the loaded shipment doesn't match the current one
        prevProps.createEditShipment.shipment && prevProps.createEditShipment.shipment.id.toString() !== shipmentId
      )) {
        if (this.props.createEditShipment.shipment.market_order) {
          const { order } = prevProps;
          if (!order.order || order.order.id !== this.props.createEditShipment.shipment.market_order) {
            prevProps.fetchOrder(this.props.createEditShipment.shipment.market_order)
          }
        }
      }
      // Get items already added in package
      const itemsAdded = getAddedItemsId(this.props.createEditShipment.shipment.packages)
      this.setState({ itemsAdded });
    }
  }

  // ---------------------------------------------------------------------------
  // Package Handling
  // ---------------------------------------------------------------------------
  onPackageAdd = (type) => {
    var newPackage = new FormData();
    newPackage.append('shipment', parseInt(this.props.createEditShipment.shipment.id, 10));
    newPackage.append('package_type', parseInt(type, 10));
    this.props.createPackage(newPackage, this.props, this.alertRef);
  };

  onPackageRemove = (id) => {
    this.props.deletePackage(id, this.alertRef);
  };

  onPackageAddItem = (packageId, items, orderItems) => {
    this.props.addItemToPackage(packageId, items);
    const {
      createEditShipment: {
        shipment: {
          market_order: shipmentOrder,
        }
      },
      order,
    } = this.props;
    if (shipmentOrder != null) {
      // If adding first inventory of item type, orderItems will be empty,
      // so we need to find the orders for that item here
      if (orderItems.length === 0 && order && order.order.id) {
        const auxOrderItems = _.filter(order.order.items, (orderItem) => {
          return orderItem.item.id === items[0].item.id
        });
        orderItems = auxOrderItems.map((orderItem) => {
          return orderItem.id.toString();
        });
      }
      const itemsAdded = getAddedItemsId(this.props.createEditShipment.shipment.packages);
      this.setState((prevState) => {
        const updatedErrors = {
          missingItems: _.filter(prevState.finishErrors.missingItems, (item) => {
            return orderItems.indexOf(item.toString()) === -1;
          }),
          fulfilledInBackOrder: _.filter(prevState.finishErrors.fulfilledInBackOrder, (item) => {
            return orderItems.indexOf(item.toString()) === -1
          }),
        }
        return {
          finishErrors: updatedErrors,
          itemsAdded,
        }
      });
    }
  };

  onPackageDeleteItem = (packageId, inventoryId) => {
    this.props.deleteItemFromPackage(packageId, inventoryId);
    const itemsAdded = getAddedItemsId(this.props.createEditShipment.shipment.packages);
    this.setState({ itemsAdded });
  };

  // ---------------------------------------------------------------------------
  // Shipment Handling
  // ---------------------------------------------------------------------------
  finishShipment = (shipmentId) => {
    let createEditShipment = this.props.createEditShipment;
    createEditShipment.loading = true;
    this.setState({ createEditShipment });
    finishShipment(shipmentId).then(() => {
      createEditShipment.loading = true;
      this.setState({ createEditShipment });
      this.alertRef.current.sendAlert('Shipment was finished successfully', "success");
      this.props.history.push('/shipment/' + shipmentId);
      this.props.fetchBackOrder(createEditShipment.shipment.market_order);
    }, ({ response }) => {
      createEditShipment.loading = false;
      this.setState({ createEditShipment });
      const errors = response.data;
      if (errors && (errors.missing_items || errors.fulfilled_in_back_order)) {
        this.setState({
          finishErrors: {
            missingItems: errors.missing_items,
            fulfilledInBackOrder: errors.fulfilled_in_back_order,
          },
        });
        this.alertRef.current.sendAlert(`Cannot finish Shipment #${shipmentId}. Some items are missing or wrongly marked in Back Order.`);
      } else if ('message' in errors) {
        this.alertRef.current.sendAlert(errors['message']);
      } else {
        this.alertRef.current.sendAlert(`Cannot finish Shipment #${shipmentId}`);
      }
    });
  };

  // ---------------------------------------------------------------------------
  // Edit Shipment Destination
  // ---------------------------------------------------------------------------
  openChangeDestinationModal = () => {
    this.setState({
      selectedDestination: this.props.createEditShipment.shipment.destination.id,
      isChangeDestinationModalOpen: true
    });
  };

  onDestinationChange = (event) => {
    this.setState({selectedDestination: event.target.value});
  };

  updateShipmentDestination = () => {
    this.props.updateShipment(
      this.props.createEditShipment.shipment.id,
      { destination: this.state.selectedDestination },
      this.alertRef,
    );
    this.setState({ isChangeDestinationModalOpen: false });
  };

  openChangeDateModal = () => {
    const date = moment(this.props.createEditShipment.shipment.creation_date).format("YYYY-MM-DD")
    this.setState({ selectedDate: date, isChangeDateModalOpen: true });
  };

  onDateChange = (event) => {
    this.setState({ selectedDate: event.target.value });
  };

  updateShipmentDate = () => {
    this.props.updateShipment(
      this.props.createEditShipment.shipment.id,
      { creation_date: moment(this.state.selectedDate).format("YYYY-MM-DDThh:mm") },
      this.alertRef,
    );
    this.setState({ isChangeDateModalOpen: false });
  };

  // ---------------------------------------------------------------------------
  // Order handling
  // ---------------------------------------------------------------------------


  // ---------------------------------------------------------------------------
  // Change 'In Back Order' status of an Order item
  // ---------------------------------------------------------------------------
  onItemBackOrderChange = (orderItemId, value) => {
    const { setOrderItemBackOrder } = this.props;
    setOrderItemBackOrder(orderItemId, value);
    if (value) {
      this.setState((prevState) => {
        const updatedErrors = {
          missingItems: _.filter(prevState.finishErrors.missingItems, (item) => {
            return item !== orderItemId
          }),
          fulfilledInBackOrder: [...prevState.finishErrors.fulfilledInBackOrder],
        }
        return {
          finishErrors: updatedErrors,
        }
      });
    } else {
      this.setState((prevState) => {
        const updatedErrors = {
          missingItems: [...prevState.finishErrors.missingItems],
          fulfilledInBackOrder: _.filter(prevState.finishErrors.fulfilledInBackOrder, (item) => {
            return item !== orderItemId
          }),
        }
        return {
          finishErrors: updatedErrors,
        }
      });
    }
    changeBackOrderStatus(orderItemId, value).catch((error) => {
      const response = error.response;
      this.alertRef.current.sendAlert('Something went wrong, please try again later');
      setOrderItemBackOrder(orderItemId, response.data.value);
    });
  };

  // ---------------------------------------------------------------------------
  // Change 'Completed Not Back Order' status of an Order item
  // ---------------------------------------------------------------------------
  onItemCompletedNotBackOrderChange = (orderItemId, value) => {
    const { setOrderItemCompletedNotBackOrder } = this.props;
    setOrderItemCompletedNotBackOrder(orderItemId, value);
    if (value) {
      this.setState((prevState) => {
        const updatedErrors = {
          missingItems: _.filter(prevState.finishErrors.missingItems, (item) => {
            return item !== orderItemId
          }),
          fulfilledInBackOrder: [...prevState.finishErrors.fulfilledInBackOrder],
        }
        return {
          finishErrors: updatedErrors,
        }
      });
    } else {
      this.setState((prevState) => {
        const updatedErrors = {
          missingItems: [...prevState.finishErrors.missingItems],
          fulfilledInBackOrder: _.filter(prevState.finishErrors.fulfilledInBackOrder, (item) => {
            return item !== orderItemId
          }),
        }
        return {
          finishErrors: updatedErrors,
        }
      });
    }
    changeItemCompletedNotBackOrderStatus(orderItemId, value).catch((error) => {
      const response = error.response;
      this.alertRef.current.sendAlert('Something went wrong, please try again later');
      setOrderItemCompletedNotBackOrder(orderItemId, response.data.value);
    });
  };

  openChangeSubstituteItemModal = (item, grade, qty) => {
    const grades = this.props.gradesList.grades.results;
    const gradeIndex = _.findIndex(grades, (o) => o.grade === grade);
    const gradeId = gradeIndex !== -1 ? grades[gradeIndex].id : -1;
    this.setState({
      itemToSubstitute: { id: item.id, grade: grade, name: item.name },
      maximumQtyToSubstitute: qty,
      selectedButcherItem: {
        item_info: { value: item.id, label: item.name },
        item_allows_grade_order: item.allows_grade_order,
      },
      selectedButcherItemQty: qty,
      errorSubstituteQty: false,
      selectedButcherItemGrade: {
        grade_index: gradeIndex,
        grade_info: gradeId,
      },
      errorSubstituteGrade: false,
      isChangeSubstituteItemModalOpen: true,
      selectedButcherInventoryId: undefined,
    });
  };

  handleButcherItemChange = (event) => {
    const { itemsList, selectedButcherItem } = this.state;
    if (event === null || event.value === undefined) {
      selectedButcherItem.item_index = -1;
      selectedButcherItem.item_allows_grade_order = false;
    } else {
      const item_index = _.findIndex(itemsList.results, (o) => o.id === event.value);
      const item = itemsList.results[item_index];
      selectedButcherItem.item_info = { value: item.id, label: item.name };
      selectedButcherItem.item_index = item.id;
      selectedButcherItem.item_allows_grade_order = item.allows_grade_order;
    }
    this.setState({
      selectedButcherItem,
      selectedButcherItemGrade: {
        grade_index: -1,
        grade_info: -1,
      },
      errorSubstituteGrade: false,
      errorSubstituteQty: false,
    });
  };

  handleButcherItemGradeChange = (event) => {
    const { selectedButcherItemGrade } = this.state;
    const { gradesList } = this.props;
    const gradeIndex = event.target.value;
    if (gradeIndex !== "-1") {
      const grade = gradesList.grades.results[gradeIndex];
      selectedButcherItemGrade.grade_info = grade.id;
      selectedButcherItemGrade.grade_index = gradeIndex;
    } else {
      selectedButcherItemGrade.grade_info = -1;
      selectedButcherItemGrade.grade_index = -1;
    }
    this.setState({ selectedButcherItemGrade, errorSubstituteGrade: false });
  };

  handleButcherInventoryIdChange = (event) => {
    const selectedButcherInventoryId = event.target.value;
    this.setState({ selectedButcherInventoryId });
    getItemFromInventory(selectedButcherInventoryId)
      .then((response) => {
        const item = response.data;
        const { selectedButcherItem } = this.state;
        if (item.station === 1) {
          selectedButcherItem.item_info = { value: item.id, label: item.name };
          selectedButcherItem.item_allows_grade_order = item.allows_grade_order
          this.setState({ selectedButcherItem });
          this.alertRef.current.sendAlert(`Scanned ${selectedButcherInventoryId} successfully.`, "success");
        } else {
          this.alertRef.current.sendAlert(`Inventory #${selectedButcherInventoryId} is not from Butcher Station.`);
        }
      })
      .catch(() => {
        this.alertRef.current.sendAlert(`Something went wrong while fetching inventory item.`);
      });
  };

  searchButcherItems = (input, callback) => {
    let options = [];
    // 1 equals to Butcher station id.
    getItems(input, null, null, 1).then((r) => {
      this.setState({ itemsList: r.data });
      r.data.results.map((item) => options.push({ value: item.id, label: item.name }));
      callback(options);
    });
  };

  handleButcherItemQtyChange = (event) => {
    const selectedButcherItemQty = event.target.value;
    const itemToBeSubstitutedMaxQty = this.state.maximumQtyToSubstitute;
    const errorSubstituteQty = selectedButcherItemQty <= 0 || selectedButcherItemQty > itemToBeSubstitutedMaxQty;
    this.setState({ selectedButcherItemQty, errorSubstituteQty });
  };

  closeQRScannerModal = () => {
    this.setState({ showQRScannerModal: false });
  };

  openQRScannerModal = () => {
    this.setState({ showQRScannerModal: true });
  };

  handleScannedInventory = (scan) => {
    const scannedInventoryId = scan;
    this.setState({ selectedButcherInventoryId: scannedInventoryId });
    getItemFromInventory(scannedInventoryId)
      .then((response) => {
        const item = response.data;
        const { selectedButcherItem } = this.state;
        if (item.station === 1) {
          selectedButcherItem.item_info = { value: item.id, label: item.name };
          this.setState({ selectedButcherItem });
          this.alertRef.current.sendAlert(`Scanned ${scannedInventoryId} successfully.`, "success");
          this.setState({
            scanResult: `Scanned ${scannedInventoryId} successfully.`,
            scanStatus: SCAN_OK,
          });
        } else {
          this.alertRef.current.sendAlert(`Inventory #${scannedInventoryId} is not from Butcher Station.`);
          this.setState({
            scanResult: `Inventory #${scannedInventoryId} is not from Butcher Station.`,
            scanStatus: SCAN_ERROR,
          });
        }
      })
      .catch(() => {
        this.alertRef.current.sendAlert(`Something went wrong while fetching inventory item.`);
        this.setState({
          scanResult: `Something went wrong while fetching inventory item.`,
          scanStatus: SCAN_ERROR,
        });
      });
    setTimeout(this.cleanMessage, SCAN_MESSAGE_DISPLAY_TIME_MS);
    this.closeQRScannerModal();
  };

  handleScanError = () => {
    this.setState({ scanStatus: SCAN_ERROR, scanResult: "Cannot scan" });
  };

  cleanMessage = () => {
    this.setState({ scanStatus: SCAN_SCANNING, scanResult: "" });
  };

  submitButcherItemChange = () => {
    const marketOrderId = this.props.createEditShipment.shipment.market_order;
    const itemToBeSubstitutedId = this.state.itemToSubstitute.id;
    const itemToBeSubstitutedName = this.state.itemToSubstitute.name;
    const itemToBeSubstitutedGrade = this.state.itemToSubstitute.grade;
    const itemToBeSubstitutedMaxQty = this.state.maximumQtyToSubstitute;
    const substituteId = this.state.selectedButcherItem.item_info.value;
    const substituteAllowsGrade = this.state.selectedButcherItem.item_allows_grade_order;
    const substituteGrade = this.state.selectedButcherItemGrade.grade_info;
    const qty = this.state.selectedButcherItemQty;
    const errorSubstituteGrade = (substituteAllowsGrade && substituteGrade === -1) || (!substituteAllowsGrade && substituteGrade !== -1);
    const errorSubstituteQty = qty > itemToBeSubstitutedMaxQty || qty <= 0;
    if (!errorSubstituteGrade && !errorSubstituteQty) {
      changeItemForSubstitute(marketOrderId, {
        item_to_be_substituted_id: itemToBeSubstitutedId,
        item_to_be_substituted_grade: itemToBeSubstitutedGrade,
        substitute_id: substituteId,
        substitute_grade: substituteGrade !== -1 ? substituteGrade : undefined,
        substitute_qty: Number(qty),
      })
        .then(() => {
          this.props.fetchOrder(marketOrderId);
          this.alertRef.current.sendAlert(`Item ${itemToBeSubstitutedName} was successfully substituted.`, "success");
        })
        .catch((error) =>
          this.alertRef.current.sendAlert(`Item ${itemToBeSubstitutedName} couldn't be substituted. ${error.response.data}`)
        );
      this.setState({ isChangeSubstituteItemModalOpen: false });
    } else {
      this.setState({ errorSubstituteQty, errorSubstituteGrade });
    }
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    if (this.props.createEditShipment.loading || !this.props.createEditShipment.shipment || !this.props.packageTypes.typesList){
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <Spinner />
        </div>
      );
    } else {
      const {
        createEditShipment: {
          shipment: {
            market_order: shipmentOrder,
          }
        },
        order,
        stationsList,
      } = this.props;
      const { itemsAdded, finishErrors } = this.state;
      return(
        <div>
          <Alert ref={this.alertRef}/>
          {/* Header */}
          <ShipmentDetailHeader
            shipment={this.props.createEditShipment.shipment}
            finishShipment={this.finishShipment}
            openChangeDestinationModal={this.openChangeDestinationModal}
            openChangeDateModal={this.openChangeDateModal}
            order={order.loading || !shipmentOrder ? undefined : order.order }
          />

          {order.order && shipmentOrder && (
            <ShipmentItemsList
              items={order.order.items}
              itemsAdded={itemsAdded}
              stations={stationsList.stations}
              handleBackOrderChange={this.onItemBackOrderChange}
              openChangeSubstituteItemModal={this.openChangeSubstituteItemModal}
              errors={finishErrors.missingItems}
            />
          )}

          {order.order && shipmentOrder && (
            <ChangeItemSubstituteModal
              setIsChangeSubstituteItemModalOpen={() => this.setState({ isChangeSubstituteItemModalOpen: false })}
              isChangeSubstituteItemModalOpen={this.state.isChangeSubstituteItemModalOpen}
              submitButcherItemChange={this.submitButcherItemChange}
              itemToSubstitute={this.state.itemToSubstitute}
              maximumQtyToSubstitute={this.state.maximumQtyToSubstitute}
              handleButcherItemChange={this.handleButcherItemChange}
              searchButcherItems={this.searchButcherItems}
              itemsList={this.props.itemsList}
              selectedButcherItem={this.state.selectedButcherItem}
              selectedButcherInventoryId={this.state.selectedButcherInventoryId}
              handleSelectedButcherInventoryIdChange={this.handleButcherInventoryIdChange}
              showQRScannerModal={this.state.showQRScannerModal}
              openQRScannerModal={this.openQRScannerModal}
              closeQRScannerModal={this.closeQRScannerModal}
              handleScannedInventory={this.handleScannedInventory}
              handleScanError={this.handleScanError}
              scanResult={this.state.scanResult}
              scanStatus={this.state.scanStatus}
              selectedButcherItemQty={this.state.selectedButcherItemQty}
              handleButcherItemQtyChange={this.handleButcherItemQtyChange}
              errorSubstituteQty={this.state.errorSubstituteQty}
              selectedButcherItemGrade={this.state.selectedButcherItemGrade}
              handleButcherItemGradeChange={this.handleButcherItemGradeChange}
              gradesList={this.props.gradesList}
              errorSubstituteGrade={this.state.errorSubstituteGrade}
            />
          )}

          {/* Packages */}
          <h4 className="card-header packages-header">Packages</h4>
          { this.props.createDeletePackage.loading?
            <Spinner />
          :
            <div></div>
          }

          {/* Packages */}
          <div className="packages-container">
            {!this.props.createEditShipment.shipment.packages || this.props.createEditShipment.shipment.packages.length === 0 ? (
              <div className="shipment-no-packages">There are no packages added to this shipment yet</div>
            ) : (
              <div>
                {this.props.createEditShipment.shipment.packages.map((p, idx) => {
                  return (
                    <Package
                      key={idx}
                      package={p}
                      order={order}
                      isOrderShipment={shipmentOrder !== null}
                      errors={finishErrors}
                      onRemove={this.onPackageRemove}
                      onAddItem={this.onPackageAddItem}
                      onDeleteItem={this.onPackageDeleteItem}
                      handleBackOrderChange={this.onItemBackOrderChange}
                      handleCompletedNotBackOrderChange={this.onItemCompletedNotBackOrderChange}
                      openChangeSubstituteItemModal={this.openChangeSubstituteItemModal}
                    />
                  );
                })}
              </div>
            )}
          </div>
          {/* Add Package */}
          <PackageCreator onPackageAdd={this.onPackageAdd} packageTypes={this.props.packageTypes.typesList} />

          {/* Change Shipment destination */}
          <Modal
            closeModal={() => this.setState({isChangeDestinationModalOpen: false})}
            isModalOpen={this.state.isChangeDestinationModalOpen}
            onConfirm={this.updateShipmentDestination}
            onCancel={() => this.setState({isChangeDestinationModalOpen: false})}
            header="Change Shipment destination"
            onConfirmButtonText="Continue"
            onCancelButtonText="Cancel"
            >
            <div className="card-block pb-0">
              <h6>Destination</h6>
              <div className="row">
                <select id="select" name="select" className="form-control" size="1"
                        value={this.state.selectedDestination}
                        onChange={this.onDestinationChange}>
                  <option value="0">Please select destination</option>
                    {this.props.destinationsList.destinations.map((d,index) => {
                          return(<option value={d.id} key={d.id}>{d.name}</option>)
                        })
                    }
                </select>
              </div>
            </div>
          </Modal>

          {/* Change Shipment date */}
          <Modal
            closeModal={() => this.setState({isChangeDateModalOpen: false})}
            isModalOpen={this.state.isChangeDateModalOpen}
            onConfirm={this.updateShipmentDate}
            onCancel={() => this.setState({isChangeDateModalOpen: false})}
            header="Change shipment creation date"
            onConfirmButtonText="Continue"
            onCancelButtonText="Cancel"
            >
            <div className="card-block pb-0">
              <h6>Creation date</h6>
              <div className="row">
                <input type="date" id="date" className="form-control" value={this.state.selectedDate} onChange={this.onDateChange} />
              </div>
            </div>
          </Modal>
        </div>
      )
    }
  }
}

// ---------------------------------------------------------------------------
// Redux
// ---------------------------------------------------------------------------
const mapStateToProps = (state, ownProps) => {
  return {
    createEditShipment: state.shipments.createEditShipment,
    order: state.orders.marketOrderDetail,
    packageTypes: state.shipments.packageTypes,
    createDeletePackage: state.shipments.createDeletePackage,
    destinationsList: state.shipments.destinationsList,
    stationsList: state.sessions.stationsList,
    itemsList: state.inventories.itemsList,
    gradesList: state.inventories.gradesList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchShipment: (id, props) => {
      dispatch(fetchShipment(id)).payload.then((response) => {
        dispatch(fetchShipmentSuccess(response.data));
      }, (error) => {
        dispatch(fetchShipmentFailure(error));
      });
    },
    fetchOrder: (id) => {
      dispatch(fetchOrderDetail(id)).payload.then((response) => {
        dispatch(fetchOrderDetailSuccess(response.data));
      }, (error) => {
        dispatch(fetchOrderDetailFailure(error));
      });
    },
    fetchPackageTypes: (props) => {
      dispatch(fetchPackageTypes()).payload.then((response) => {
        dispatch(fetchPackageTypesSuccess(response.data));
      }, (error) => {
        dispatch(fetchPackageTypesFailure(error));
      });
    },
    createPackage: (data, props, alertRef) => {
      dispatch(createPackage(data)).payload.then((response) => {
        dispatch(createPackageSuccess(response.data));
        let pType = props.packageTypes.typesList.find((pt) => {
          return pt.id === response.data.package_type;
        });
        let p = {id: response.data.id, package_type: pType, items: []};
        dispatch(addPackageToState(p));
        alertRef.current.sendAlert(`Package ${p.id} successfully added`, "success");
      }, (error) => {
        dispatch(createPackageFailure(error));
        alertRef.current.sendAlert(`Cannot add package`);
      });
    },
    deletePackage: (id, alertRef) => {
      dispatch(deletePackage(id)).payload.then((response) => {
        dispatch(deletePackageSuccess(response.data));
        dispatch(deletePackageFromState(id));
        alertRef.current.sendAlert(`Package ${id} successfully deleted`, "success");
      }, (error) => {
        dispatch(deletePackageFailure(error));
        alertRef.current.sendAlert(`Cannot delete Package ${id}`);
      });
    },
    deleteItemFromPackage: (packageId, itemID, props) => {
      dispatch(deleteItemFromPackage(packageId, itemID));
    },
    addItemToPackage: (packageId, item, props) => {
      dispatch(addItemToPackage(packageId, item));
    },
    fetchDestinations: (alertRef) => {
      dispatch(fetchDestinations()).payload.then((response) => {
        dispatch(fetchDestinationsSuccess(response.data));
      }, (error) => {
        dispatch(fetchDestinationsFailure(error));
        alertRef.current.sendAlert('Something went wrong');
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
    updateShipment: (id, data, alertRef) => {
      dispatch(updateShipment(id, data)).payload.then((response) => {
        dispatch(updateShipmentSuccess(response.data));
        dispatch(fetchShipment(id)).payload.then((response) => {
          dispatch(fetchShipmentSuccess(response.data));
        }, (error) => {
          dispatch(fetchShipmentFailure(error));
        });
      }, (error) => {
        dispatch(updateShipmentFailure(error));
        alertRef.current.sendAlert('Something went wrong');
      });
    },
    setOrderItemBackOrder: (orderItemId, value) => {
      dispatch(changeOrderItemBackOrder(orderItemId, value));
    },
    setOrderItemCompletedNotBackOrder: (orderItemId, value) => {
      dispatch(changeOrderItemCompletedNotBackOrder(orderItemId, value));
    },
    fetchBackOrder: (id) => {
      dispatch(fetchBackOrderDetail(id)).payload.then((response) => {
        dispatch(fetchBackOrderDetailSuccess(response.data));
      }, (error) => {
        dispatch(fetchBackOrderDetailFailure(error));
      });
    },
    filterItems: (query, station, page) => {
      dispatch(fetchItems(query, station, page)).payload.then(
        (response) => {
          dispatch(fetchItemsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchItemsFailure(error));
        }
      );
    },
    fetchGrades: () => {
      dispatch(fetchGrades()).payload.then(
        (response) => {
          dispatch(fetchGradesSuccess(response.data));
        },
        (error) => {
          dispatch(fetchGradesFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShipmentEditContainer));
